import yup from "../../yup/yupInterface";
import {
  DEFAULT_MINIMUM_PHONE_NUMBER_LENGTH,
  MOBILE_RULES,
} from "../../../config/constants";
import { useProfileStore } from "../profileStore";
import {
  DEFAULT_PHONE_NUMBER_PATTERN,
  INDONESIA_PHONE_NUMBER_PATTERN,
} from "../../../components/MobileInput/PhoneNumber";

export type MobileFormValues = {
  countryCode: string;
  phoneNumber: string;
};

export const MobileSchema = () => {
  const country = useProfileStore.getState().country;
  const pattern =
    country === "id-ID"
      ? INDONESIA_PHONE_NUMBER_PATTERN
      : DEFAULT_PHONE_NUMBER_PATTERN;

  return yup.object({
    countryCode: yup.string().required("COUNTRY_CODE_REQUIRED"),
    phoneNumber: yup
      .string()
      .required("REQUIRED")
      .test(
        "phone-number-length",
        "INCOMPLETE_MOBILE",
        function validate(value) {
          const { countryCode } = this.parent as MobileFormValues;
          const phoneNumberMinLength: number =
            MOBILE_RULES[countryCode?.replace(/[^0-9]/g, "")]
              ?.phoneNumberMinLength || DEFAULT_MINIMUM_PHONE_NUMBER_LENGTH;

          return value.length >= Number(phoneNumberMinLength);
        }
      )
      .matchesPattern(new RegExp(pattern), "INVALID_PHONE_NUMBER_PATTERN"),
  });
};
